import { lazy } from 'react';
const RetailForecast = lazy(() => import('./RetailForecast'));

const RetailForecastConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/retailForecast',
            element: <RetailForecast />,
        },

    ],
};

export default RetailForecastConfig;
